import React from 'react';
import wb0 from '../img/Detail/Nova-Detail.jpg';
import './Detail.css';
const NovaDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default NovaDetail;